import Model, { executeMutation, ID, JsonArray } from 'src/models/model'

export default class ArchivableModel extends Model {
  static name = 'ArchivableModel'

  static define () {
    this.fields = {
      modelClass: {
        type: String,
        output: true
      },
      modelId: {
        type: ID,
        output: true
      },
      archives: {
        type: JsonArray,
        output: true
      },
      blocks: {
        type: JsonArray,
        output: true
      },
      warns: {
        type: JsonArray,
        output: true
      },
      nullifies: {
        type: JsonArray,
        output: true
      }
    }

    this.queries = {
      archivableModel: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          archivable: ArchivableModel
        }
      }
    }
  }

  static archiveModel (modelClass, modelId, nullify = false) {
    return executeMutation(
      'archiveArchivableModel',
      { modelClass, modelId, nullify },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  archiveModel (modelClass, modelId, nullify = false) {
    return this.constructor.archiveModel(modelClass, modelId, nullify)
  }

  static unarchiveModel (modelClass, modelId) {
    return executeMutation(
      'unarchiveArchivableModel',
      { modelClass, modelId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  unarchiveModel (modelClass, modelId) {
    return this.constructor.unarchiveModel(modelClass, modelId)
  }
}
